import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MenuItem } from '@r1-development/rps-shared-ui';

/**
 * IconCellComponent serves for rendering just a given icon or icon with menu on click.
 * For icon with menu, set isIconMenu = true, send menuItems and iconName as renderer params
 * For only icon, it takes from params.value
 */

@Component({
    selector: 'app-icon-component',
    templateUrl: './icon-cell.component.html',
    styleUrls: ['./icon-cell.component.scss'],
    standalone: false
})
export class IconCellComponent implements ICellRendererAngularComp {
  value: string;
  isIconMenu = false;
  iconName = '';
  iconColor = '#316094';
  iconSize = 'md';
  menuItems: MenuItem[];
  icon = {
    iconName: '',
    iconColor: '',
    iconSize: 'md',
  };

  tooltip = '';
  private params: ICellRendererParams | any;

  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    const dataParams = params?.colDef?.cellRendererParams;
    this.isIconMenu = dataParams?.isIconMenu;
    if (dataParams?.iconColor) {
      if (typeof dataParams.iconColor === 'function') {
        this.iconColor = dataParams.iconColor(params);
      } else {
        this.iconColor = dataParams.iconColor;
      }
    }

    if (dataParams?.tooltip) {
      if (typeof dataParams.tooltip === 'function') {
        this.tooltip = dataParams?.tooltip(params);
      }
    }

    this.iconName = params?.value;
    if (dataParams?.icon) {
      this.setIcon(dataParams, params);
    }

    if (this.isIconMenu) {
      this.menuItems = dataParams?.menuItems(params);
      this.addMenuItemCommand();
    }
  }

  refresh(): boolean {
    return false;
  }

  getIconClass(name: string): string {
    return 'r1-icon r1-icon-' + name;
  }

  private addMenuItemCommand(): void {
    this.menuItems.forEach((item: MenuItem) => {
      item.command = () => {
        this.clickHandler(item);
      };
    });
  }

  private clickHandler(item: MenuItem): void {
    this.params?.clicked({ params: this.params, item });
  }

  private setIcon(dataParams: any, params: ICellRendererParams<any, any>) {
    let icon = null;
    if (typeof dataParams.icon === 'function') {
      icon = dataParams?.icon(params);
    } else {
      icon = dataParams?.icon;
    }
    this.iconName = icon?.iconName ? icon?.iconName : params?.value;
    this.iconColor = icon?.iconColor ? icon?.iconColor : '#316094';
    this.iconSize = icon?.iconSize ? icon?.iconSize : 'md';
  }
}
